import Cookies from 'js-cookie';
import {LocalStorageKey} from '@store/@types/util/LocalStorageKey';

export function deleteAllCookies() {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    deleteCookie(name);
  }
}

export function deleteCookie(name) {
  Cookies.remove(name, {path: '/'});
}

export function clearLocalStorage() {
  const retainKeys: string[] = [LocalStorageKey.WIDGET_STATE, LocalStorageKey.WEB_DATA_ROCKS];

  // Remove all entries that aren't listed above
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && !retainKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  }
}

export enum LoginErrorType {
  NEEDS_SSO = 'Account has disabled sign-in; Use SSO instead',
  NEEDS_CAPTCHA = 'Captcha needed',
  INVALID_CREDENTIALS = 'Invalid Credentials',
}
